module.exports = __webpack_public_path__ + "static/01-407fc27ee130e6763f5959333c2b0d71.jpg";